import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import VueResource from 'vue-resource';
import VueJwtDecode from 'vue-jwt-decode';
import swal from 'sweetalert';

Vue.config.productionTip = false;

Vue.use(VueJwtDecode);
Vue.use(VueResource);

Vue.http.options.root = 'https://psicometricosfapsi.com/biologicas/api/public/pri';
//Vue.http.options.root = './api/public/pri';

localStorage.apikeySiepsBiologicasUanl=JSON.stringify("eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzaWVwc191YW5sX3Bvc2dyYWRvIiwiZGF0YSI6eyJpZHNvbGljaXR1ZCI6IjEiLCJpZGFsdW1ubyI6IjEifSwiaWF0IjoxNzE4ODM2MTM2LCJleHAiOjIwMzQzNjg5MzZ9.duBO5wP9M2_ttUAxXwcAIeIoxw0zom2Nlr0qX4RM7yg");

Vue.http.interceptors.push((request, next) => {
  if (!localStorage.getItem('apikeySiepsBiologicasUanl') || localStorage.getItem('apikeySiepsBiologicasUanl')=='undefined' || localStorage.getItem('apikeySiepsBiologicasUanl')==undefined) {
    localStorage.apikeySiepsBiologicasUanl=JSON.stringify("eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJzaWVwc191YW5sX3Bvc2dyYWRvIiwiZGF0YSI6eyJpZHNvbGljaXR1ZCI6IjEiLCJpZGFsdW1ubyI6IjEifSwiaWF0IjoxNzE4ODM2MTM2LCJleHAiOjIwMzQzNjg5MzZ9.duBO5wP9M2_ttUAxXwcAIeIoxw0zom2Nlr0qX4RM7yg");
  }
  request.headers.set('Authorization', 'Bearer '+JSON.parse(localStorage.apikeySiepsBiologicasUanl))
  request.headers.set('Accept', 'application/json')
  next(res => {
  })
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js